export type DrillLayoutMode = 'grid' | 'list';

export interface DrillCardPreferences {
    showThumbnail: boolean;
    showDescription: boolean;
    showTags: boolean;
    maxTagCount: number; // -1 represents all available tags
}

export const defaultDrillCardPreferences: DrillCardPreferences = {
    showThumbnail: true,
    showDescription: true,
    showTags: true,
    maxTagCount: 6,
};
